import { ShowArticleDialogComponent } from "./pages/show-article-dialog/show-article-dialog.component";
import { ThirdpartyliabrariesComponent } from "./pages/thirdpartyliabraries/thirdpartyliabraries.component";
import { CommunityGuidelinesComponent } from "./pages/community-guidelines/community-guidelines.component";
import { CookiePolicyComponent } from "./pages/cookie-policy/cookie-policy.component";
import { LawEnforcementComponent } from "./pages/law-enforcement/law-enforcement.component";
import { BundleqrcodeComponent } from "./pages/bundleqrcode/bundleqrcode.component";
import { ReportBundleComponent } from "./pages/report-bundle/report-bundle.component";
import { DeleteBundleDialogComponent } from "./pages/delete-bundle-dialog/delete-bundle-dialog.component";
import { EditBundleComponent } from "./pages/edit-bundle/edit-bundle.component";
import { RestrictedforbundleComponent } from "./pages/restrictedforbundle/restrictedforbundle.component";
import { ViewBundleComponent } from "./pages/view-bundle/view-bundle.component";
import { AddflowsinBundleComponent } from "./pages/addflowsin-bundle/addflowsin-bundle.component";
import { CreatebundleComponent } from "./pages/createbundle/createbundle.component";
import { EditFlowComponent } from "./pages/edit-flow/edit-flow.component";
import { RestrictedAccessComponent } from "./pages/restricted-access/restricted-access.component";
import { ImageDialogComponent } from "./pages/image-dialog/image-dialog.component";
import { AboutUsComponent } from "./pages/about-us/about-us.component";
import { HowItWorksComponent } from "./pages/how-it-works/how-it-works.component";
import { CaptureImageComponent } from "./pages/capture-image/capture-image.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";
import { SampleComponent } from "./pages/sample/sample.component";
import { EmployeeComponent } from "./pages/employee/employee.component";
import { LoginComponent } from "./pages/login/login.component";
import { OrgOnboardingComponent } from "./pages/org-onboarding/org-onboarding.component";
import { OrgAdminComponent } from "./pages/org-admin/org-admin.component";
import { OrgJoinComponent } from "./pages/org-join/org-join.component";
import { ViewflowComponent } from "./pages/viewflow/viewflow.component";
import { PerformTaskComponent } from "./pages/perform-task/perform-task.component";
import { PrivacypolicyComponent } from "./privacypolicy/privacypolicy.component";
import { TermsandconditionsComponent } from "./termsandconditions/termsandconditions.component";
import { ViewbyidComponent } from "./pages/viewbyid/viewbyid.component";
import { BrowserModule } from "@angular/platform-browser";
import { ReactiveFormsModule } from "@angular/forms";
import { ViewByIdResolver } from "./pages/viewbyid/viewbyid.resolver";
import { FlowByCategoryComponent } from "./pages/flow-by-category/flow-by-category.component";
import { RegistrationComponent } from "./pages/registration/registration.component";
import { UserProfileComponent } from "./pages/user-profile/user-profile.component";
import { EditProfileComponent } from "./pages/edit-profile/edit-profile.component";
import { PreviewPageComponent } from "./pages/preview-page/preview-page.component";
import { EmbedPreviewComponent } from "./pages/embed-preview/embed-preview.component";
import { ForgetPasswordComponent } from "./pages/user-settings/forget-password/forget-password.component";
import { ChangePasswordComponent } from "./pages/change-password/change-password.component";
import { ViewProfileComponent } from "./pages/view-profile/view-profile.component";
import { QRCodeComponent } from "./pages/qrcode/qrcode.component";
import { CommentComponent } from "./pages/comment/comment.component";
import { EditCommentComponent } from "./pages/edit-comment/edit-comment.component";
import { ChangeOldPasswordComponent } from "./pages/user-settings/change-old-password/change-old-password.component";
import { CreateFlowComponent } from "./pages/create-flow/create-flow.component";
import { CreateFlowSelectionComponent } from "./pages/create-flow-selection/create-flow-selection.component";
import { QuickCreateFlowComponent } from "./pages/quick-create-flow/quick-create-flow.component";
import { FlowchestAiCreateFlowComponent } from "./pages/flowchest-ai-create-flow/flowchest-ai-create-flow.component";
import { CoverPageComponent } from "./pages/cover-page/cover-page.component";
import { CategoriesComponent } from "./pages/categories/categories.component";
import { ItemsComponent } from "./pages/items/items.component";
import { StepsComponent } from "./pages/steps/steps.component";
import { NotificationsComponent } from "./pages/notifications/notifications.component";
import { SearchComponent } from "./pages/search/search.component";
import { BulbGuideComponent } from "./pages/bulb-guide/bulb-guide.component";
import { InAppropriateComponent } from "./pages/in-appropriate/in-appropriate.component";
import { FollowersComponent } from "./pages/followers/followers.component";
import { FollowingComponent } from "./pages/following/following.component";
import { UserProfileQrCodeComponent } from "./pages/user-profile-qr-code/user-profile-qr-code.component";
import { ActivateaccountComponent } from "./pages/activateaccount/activateaccount.component";
import { ArticleComponent } from "./pages/article/article.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { SubscriptionsComponent } from "./pages/subscriptions/subscriptions.component";
import { CreateContentGuard } from "./create-content.guard";
import { AuthGuard } from "./auth.guard";
import { OrgAccessGuard } from "./org-access.guard";
import { AdminGuard } from "./admin.guard";
import { CheckoutComponent } from "./pages/checkout/checkout.component";
import { VouchercodeComponent } from "./pages/vouchercode/vouchercode.component";
import { UserDashboardComponent } from "./pages/user-dashboard/user-dashboard.component";
import { AdminDashboardComponent } from "./pages/admin-dashboard/admin-dashboard.component";
import { EmbededComponent } from "./pages/embeded/embeded.component";
import { EmbedforbundlesComponent } from "./pages/embedforbundles/embedforbundles.component";
import { EditItemComponent } from "./pages/edit-item/edit-item.component";
import { AnalyticsComponent } from "./pages/analyics/analytics.component";
import { CouponCodeComponent } from "./pages/user-settings/coupon-code/coupon-code.component";
import { PricingplanComponent } from "./pages/pricingplan/pricingplan.component";
import { PurchaseCoinsComponent } from "./pages/purchase-coins/purchase-coins.component";
import { PurchaseGuideSlotsComponent } from "./pages/purchase-guide-slots/purchase-guide-slots.component";
import { PreviewBlogComponent } from "./pages/blogs/blog/blog.component";
import { BlogsComponent } from "./pages/blogs/blogs.component";
import { DeleteUserDialogComponent } from "./pages/delete-user-dialog/delete-user-dialog.component";
import { SelectionRephraseAIComponent } from "./pages/selection-rephraseAi-dialog/selection-rephraseAi-dialog.component";
import { FaqComponent } from "./pages/faq/faq.component";
import { FaqSupportPageComponent } from "./pages/faq-support-page/faq-support-page.component";
import { GiftedfundsComponent } from "./pages/user-dashboard/giftedfunds/giftedfunds.component";
import { BookconsultationsComponent } from "./pages/bookconsultations/bookconsultations.component";
import { ConsultationsComponent } from "./pages/user-dashboard/consultations/consultations.component";
import { ScheduleconsultationsComponent } from "./pages/user-dashboard/scheduleconsultations/scheduleconsultations.component";
import { SettingsComponent } from "./pages/settings/settings.component";
import { FeedbackformsComponent } from "./pages/feedbackforms/feedbackforms.component";
import { CreateBlogComponent } from "./pages/create-blog/create-blog.component";
import { ShowPermissionsComponent } from "./pages/show-permissions/show-permissions.component";
import { CreateAboutUsComponent } from "./pages/create-about-us/create-about-us.component";
import { SendFeedbackComponent } from "./pages/send-feedback/send-feedback.component";
import { ContactUsComponent } from "./pages/contact-us/contact-us.component";
import { CollaborationRequestsComponent } from "./pages/user-dashboard/collaboration-requests/collaboration-requests.component";

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "enabled",
  anchorScrolling: "enabled",
  scrollOffset: [0, 464],
};

const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "org/onboarding",
    component: OrgOnboardingComponent,
    canActivate: [AuthGuard, OrgAccessGuard],
    data: { orgAccess: "setup" },
  },
  {
    path: "org/admin",
    component: OrgAdminComponent,
    canActivate: [AuthGuard, OrgAccessGuard],
    data: { orgAccess: "admin" },
  },
  {
    path: "org/join",
    component: OrgJoinComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "pricing",
    component: PricingplanComponent,
  },
  {
    path: "send-feedback",
    component: SendFeedbackComponent,
  },
  {
    path: "contact-us",
    component: ContactUsComponent,
  },
  {
    path: "blog/:title",
    component: PreviewBlogComponent,
  },
  {
    path: "registration",
    component: RegistrationComponent,
  },
  // {
  //   path: "grid",
  //   component: SearchComponent,
  // },
  {
    path: "activateaccount",
    component: ActivateaccountComponent,
  },
  {
    path: "show-permissions",
    component: ShowPermissionsComponent,
  },
  {
    path: "subscriptions",
    component: SubscriptionsComponent,
  },
  {
    path: "purchase-coins",
    component: PurchaseCoinsComponent,
  },
  {
    path: "purchase-guide-slots",
    component: PurchaseGuideSlotsComponent,
  },
  // {
  //   path: "user-dashboard",
  //   component: UserDashboardComponent,
  // },
  {
    path: "user-dashboard",
    loadChildren: () =>
      import("./pages/user-dashboard/user-dashboard.module").then(
        (m) => m.UserDashboardModule
      ),
  },
  {
    path: "adminctrl",
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () =>
      import("./pages/admin-dashboard/admin-dashboard.module").then(
        (m) => m.AdminDashboardModule
      ),
  },
  {
    path: "user-settings",
    loadChildren: () =>
      import("./pages/user-settings/user-settings.module").then(
        (m) => m.UserSettingsModule
      ),
  },
  {
    path: "privacy",
    component: PrivacypolicyComponent,
  },
  {
    path: "tandc",
    component: TermsandconditionsComponent,
  },
  {
    path: "viewbyid:/id",
    component: ViewflowComponent,
    resolve: { resolvedata: ViewByIdResolver },
  },
  {
    path: "detail/:id",
    component: ViewbyidComponent,
    resolve: {
      resolvedata: ViewByIdResolver,
    },
  },
  {
    path: "view",
    component: ViewflowComponent,
  },
  {
    path: "guide/:title/:rowKey",
    component: ViewflowComponent,
  },
  {
    path: "perform/:title/:rowKey",
    component: PerformTaskComponent,
  },
  {
    path: "embed/guide/:title/:rowKey",
    component: ViewflowComponent,
    data: { embedMode: true },
  },
  {
    path: "embed/guide-pack/:title/:rowKey",
    component: ViewBundleComponent,
    data: { embedMode: true },
  },
  {
    path: "embed/bundle/:title/:rowKey",
    redirectTo: "embed/guide-pack/:title/:rowKey",
  },
  {
    path: "embed-preview",
    component: EmbedPreviewComponent,
  },
  {
    path: "guide-by-category",
    component: FlowByCategoryComponent,
  },
  {
    path: "flowbycategory",
    redirectTo: "guide-by-category",
    pathMatch: "full",
  },
  {
    path: "notifications",
    component: NotificationsComponent,
  },
  {
    path: "user-profile",
    component: UserProfileComponent,
  },
  {
    path: "edit-profile",
    component: EditProfileComponent,
  },
  {
    path: "preview-page",
    component: PreviewPageComponent,
  },
  // {
  //   path: "forget-password",
  //   component: ForgetPasswordComponent,
  // },
  {
    path: "change-password",
    component: ChangePasswordComponent,
  },
  // {
  //   path: "change-old-password",
  //   component: ChangeOldPasswordComponent,
  // },
  {
    path: "view-profile",
    component: ViewProfileComponent,
  },
  {
    path: "view-profile/:uname",
    component: ViewProfileComponent,
  },
  {
    path: "qrcode",
    component: QRCodeComponent,
  },
  {
    path: "comment",
    component: CommentComponent,
  },
  {
    path: "edit-comment",
    component: EditCommentComponent,
  },
  {
    path: "create-guide/selection",
    component: CreateFlowSelectionComponent,
    canActivate: [CreateContentGuard],
    data: { allowWithoutPlan: true },
  },
  {
    path: "create-guide/quick",
    component: QuickCreateFlowComponent,
    canActivate: [CreateContentGuard],
    data: { trialGate: "ai" },
  },
  {
    path: "create-guide/flowchest-ai",
    component: FlowchestAiCreateFlowComponent,
    canActivate: [CreateContentGuard],
    data: { trialGate: "ai" },
  },
  {
    path: "create-guide/manual",
    component: CreateFlowComponent,
    canActivate: [CreateContentGuard],
  },
  {
    path: "create-guide",
    component: CreateFlowComponent,
    canActivate: [CreateContentGuard],
  },
  {
    path: "create-flow/selection",
    redirectTo: "create-guide/selection",
    pathMatch: "full",
  },
  {
    path: "create-flow/quick",
    redirectTo: "create-guide/quick",
    pathMatch: "full",
  },
  {
    path: "create-flow/flowchest-ai",
    redirectTo: "create-guide/flowchest-ai",
    pathMatch: "full",
  },
  {
    path: "create-flow/manual",
    redirectTo: "create-guide/manual",
    pathMatch: "full",
  },
  {
    path: "create-flow",
    redirectTo: "create-guide",
    pathMatch: "full",
  },
  {
    path: "cover-page",
    component: CoverPageComponent,
  },
  {
    path: "categories",
    component: CategoriesComponent,
  },
  {
    path: "in-Appropriate",
    component: InAppropriateComponent,
  },

  {
    path: "items",
    component: ItemsComponent,
  },
  {
    path: "edititem",
    component: EditItemComponent,
  },
  // {
  //   path: "couponcode",
  //   component: CouponCodeComponent,
  // },
  {
    path: "analytics",
    component: AnalyticsComponent,
  },
  {
    path: "capture-image",
    component: CaptureImageComponent,
  },
  {
    path: "steps",
    component: StepsComponent,
  },
  // {
  //   path: "home",
  //   component: SearchComponent,
  // },
  {
    path: "privacypolicy",
    component: PrivacypolicyComponent,
  },
  {
    path: "termsandconditions",
    component: TermsandconditionsComponent,
  },
  {
    path: "bulbguide",
    component: BlogsComponent,
  },
  {
    path: "aboutus",
    component: AboutUsComponent,
  },
  {
    path: "how-it-works",
    component: HowItWorksComponent,
  },
  {
    path: "imageDialog",
    component: ImageDialogComponent,
  },
  {
    path: "followers",
    component: FollowersComponent,
  },
  {
    path: "following",
    component: FollowingComponent,
  },
  {
    path: "restrictedPage",
    component: RestrictedAccessComponent,
  },
  {
    path: "edit-guide",
    component: EditFlowComponent,
  },
  {
    path: "editFlow",
    redirectTo: "edit-guide",
    pathMatch: "full",
  },
  {
    path: "create-guide-pack",
    component: CreatebundleComponent,
    canActivate: [CreateContentGuard],
    data: { trialGate: "guide-packs" },
  },
  {
    path: "createbundle",
    redirectTo: "create-guide-pack",
    pathMatch: "full",
  },
  {
    path: "createAboutUs",
    component: CreateAboutUsComponent,
  },
  // {
  //   path: "createPolicies",
  //   component: CreatebundleComponent,
  // },
  {
    path: "view-guide-pack",
    component: ViewBundleComponent,
  },
  {
    path: "edit-guide-pack/:id",
    component: EditBundleComponent,
  },
  {
    path: "view-guide-pack/:id",
    component: ViewBundleComponent,
  },
  {
    path: "viewbundle",
    redirectTo: "view-guide-pack",
    pathMatch: "full",
  },
  {
    path: "editbundle/:id",
    redirectTo: "edit-guide-pack/:id",
  },
  {
    path: "viewbundle/:id",
    redirectTo: "view-guide-pack/:id",
  },
  {
    path: "userQrCode",
    component: UserProfileQrCodeComponent,
  },
  {
    path: "restricted-guide-pack",
    component: RestrictedforbundleComponent,
  },
  {
    path: "restrictedbundle",
    redirectTo: "restricted-guide-pack",
    pathMatch: "full",
  },
  {
    path: "delete-guide-pack-dialog",
    component: DeleteBundleDialogComponent,
  },
  {
    path: "deleteBundleDialog",
    redirectTo: "delete-guide-pack-dialog",
    pathMatch: "full",
  },
  {
    path: "deleteUserDialog",
    component: DeleteUserDialogComponent,
  },
  {
    path: "selectionRephraseAIComponent",
    component: SelectionRephraseAIComponent,
  },
  {
    path: "add-guides-to-guide-pack",
    component: AddflowsinBundleComponent,
  },
  {
    path: "addFlowBundle",
    redirectTo: "add-guides-to-guide-pack",
    pathMatch: "full",
  },
  {
    path: "faq",
    component: FaqSupportPageComponent,
  },
  {
    path: "report-guide-pack",
    component: ReportBundleComponent,
  },
  {
    path: "reportBundle",
    redirectTo: "report-guide-pack",
    pathMatch: "full",
  },
  {
    path: "thirdparty",
    component: ThirdpartyliabrariesComponent,
  },
  {
    path: "community-guidelines",
    component: CommunityGuidelinesComponent,
  },
  {
    path: "cookie-policy",
    component: CookiePolicyComponent,
  },
  {
    path: "law-enforcement",
    component: LawEnforcementComponent,
  },
  {
    path: "legal",
    redirectTo: "termsandconditions",
    pathMatch: "full",
  },
  {
    path: "article",
    component: ArticleComponent,
  },
  {
    path: "guide-pack-qrcode",
    component: BundleqrcodeComponent,
  },
  {
    path: "bundleqrcode",
    redirectTo: "guide-pack-qrcode",
    pathMatch: "full",
  },
  {
    path: "showArticle",
    component: ShowArticleDialogComponent,
  },
  {
    path: "vouchercode",
    component: VouchercodeComponent,
  },
  {
    path: "",
    component: SearchComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "checkout",
    component: CheckoutComponent,
  },
  {
    path: "embeded",
    component: EmbededComponent,
  },
  {
    path: "embed-for-guide-packs",
    component: EmbedforbundlesComponent,
  },
  {
    path: "embedforbundles",
    redirectTo: "embed-for-guide-packs",
    pathMatch: "full",
  },
  // {
  //   path: "gift",
  //   component: GiftedfundsComponent,
  // },
  {
    path: "bookconsultation",
    redirectTo: "/",
    pathMatch: "full",
  },
  // {
  //   path: "my-consultation",
  //   component: ConsultationsComponent,
  // },
  // {
  //   path: "pending-consultations",
  //   component: ScheduleconsultationsComponent,
  // },
  {
    path: "collaboration-requests",
    component: CollaborationRequestsComponent,
  },
  {
    path: "settings",
    component: SettingsComponent,
  },
  {
    path: "feedback",
    component: FeedbackformsComponent,
  },
  {
    path: "blog",
    component: CreateBlogComponent,
  },
  { path: "404", component: NotFoundComponent },
  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      scrollOffset: [0, 80],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
